/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'boilerplate.components.Forms';

export default defineMessages({
  action: {
    id: `${scope}.action`,
    defaultMessage: 'Salva preventivo',
  },
  terms: {
    id: `${scope}.terms`,
    defaultMessage:
      '*Il prezzo del canone mensile è soggetto a variazioni. Offerta economica limitata valida fino ad esaurimento scorte.',
  },
});
